module.exports = __webpack_public_path__ + "static/media/iconn.ce51de58.svg";